
export default {
  fbData : {},
  isFbVerified: false,
  slackData: {},
  isSlackVerified: false,  
  discordData: {},
  isDiscordVerified: false,
  linkedInData: {},
  isLinkedInVerified: false,
  twitterData: {},
  isTwitterVerified: false,
}